export function isoNow(): string {
  return (new Date).toISOString()
}
